
const initialState = {
    data: [
        {date: '2002_12', title: '2002 - prosinec'},
        {date: '2012_02', title: '2012 - únor'},
        {date: '2012_06', title: '2012 - červen'},
        {date: '2013_01', title: '2013 - leden'},
        {date: '2013_07', title: '2013 - červenec'},
        {date: '2014_01', title: '2014 - leden'},
        {date: '2014_07', title: '2014 - červenec'},
        {date: '2015_01', title: '2015 - leden'},
        {date: '2015_08', title: '2015 - srpen'},
        {date: '2016_01', title: '2016 - leden'},
        {date: '2016_07', title: '2016 - červenec'},
        {date: '2017_01', title: '2017 - leden'},
        {date: '2017_07', title: '2017 - červenec'},
        {date: '2018_01', title: '2018 - leden'},
        {date: '2018_07', title: '2018 - červenec'},
        {date: '2019_01', title: '2019 - leden'},

        {date: '2020_07', title: '2020 - červenec (wH)'},
        {date: '2020_12', title: '2020 - prosinec (wH)'},
        {date: '2021_12', title: '2021 - prosinec (wH)'},
        {date: '2022_12', title: '2022 - prosinec (wH)'},
        {date: '2023_12', title: '2023 - prosinec (wH)'},
        {date: '2024_12', title: '2024 - prosinec (wH)'},
        {date: 'actual', title: 'aktuální (wH)'},
    ]
};

export function getIsknDateTitle(state, isknDate) {
    return state.data.reduce((previous, current) => {
        return (current.date === isknDate)
            ? current.title
            : previous;
    }, isknDate);
}

export default function iskn(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}